module.exports = __webpack_public_path__ + "static/img/sm_14.d35088f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/sm_14.png
// module id = cF3E
// module chunks = 0